export enum EstimateWidgetProgress {
  INFO = 'info',
  PRICES = 'prices',
  LEAD_FORM = 'leadForm',
  LOADING = 'loading',
  SALES = 'sales',
}
